/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Notification, updateNotification } from '../../../../store/Notifications';
import { TextBlock } from '../../../Atoms/Text';

interface FileMigrationContent {
  assets_with_files: number;
  files_errored: number;
  files_migrated: number;
}

export const FileMigrationComplete = ({ notification }: { notification: Notification }) => {
  const content = notification.notification_message.content as unknown as FileMigrationContent;
  const filesMigrated = content?.files_migrated ?? 0;
  const assetsWithFiles = content?.assets_with_files ?? 0;
  const filesErrored = content?.files_errored ?? 0;

  return (
    <div
      className="space-y-1 hover:cursor-pointer ml-9"
      onClick={() =>
        updateNotification({
          ...notification,
          is_read: true
        })
      }>
      <TextBlock
        size="sm"
        weight="normal">
        We were able to identify and associate <strong>{filesMigrated}</strong> files to the{' '}
        <strong>{assetsWithFiles}</strong> Assets that you&apos;ve converted to Portal Assets.{' '}
        <strong>{filesErrored}</strong> files encountered errors.
      </TextBlock>
    </div>
  );
};
